/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-08-31T14:40:13+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import SlideInChild from './SlideInChild';

class SlideIn extends Component {
  render() {
    const {
      children,
      childStyle,
      direction,
      style,
      ...other
    } = this.props;

    const mergedRootStyles = Object.assign({}, {
      position: 'relative',
      overflow: 'hidden',
    }, style);

    const newChildren = React.Children.map(children, (child) => {
      return (
        <SlideInChild
          key={child.key}
          direction={direction}
          getLeaveDirection={this.getLeaveDirection}
          style={childStyle}
        >
          {child}
        </SlideInChild>
      );
    }, this);

    return (
      <TransitionGroup
        {...other}
        style={mergedRootStyles}
      >
        {newChildren}
      </TransitionGroup>
    );
  }

    getLeaveDirection = () => {
      return this.props.direction;
    };
}
SlideIn.propTypes = {
  childStyle: PropTypes.object,
  children: PropTypes.node,
  direction: PropTypes.oneOf(['left', 'right', 'up', 'down']),
  style: PropTypes.object,
};
SlideIn.defaultProps = {
  direction: 'left',
};
export default SlideIn;

